import {
  ADMIN_CONSIGNMENT_SUPPLIER_ENDPOINT,
  ADMIN_STORES_ENDPOINT
} from "../../constants/endpoints";
import axios from "axios";
import {ResponseModel} from "../../models/ResponseModel";
import { PaginateModel } from '../../models/PaginateModel'
import {IStoreModel, TSearch} from "../../models/StoreModel";
import { ConsignSupplierModel, SearchModel } from "../../modules/auth/models/ConsignmentsModel";

export function getList(params?: TSearch) {
  return axios.get<PaginateModel<IStoreModel>>(ADMIN_STORES_ENDPOINT, {params});
}

export function create(params: object) {
  return axios.post<ResponseModel>(ADMIN_STORES_ENDPOINT, params);
}

export function getDetail(id?: number) {
  return axios.get<ResponseModel>(`${ADMIN_STORES_ENDPOINT}/${id}`);
}

export function getStore(params: any) {
  return axios.get<ResponseModel>(`${ADMIN_STORES_ENDPOINT}`, {params})
}

export function update(params: object, id?: number) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/update/${id}`, params);
}

export function destroy(id: number) {
  return axios.delete<ResponseModel>(`${ADMIN_STORES_ENDPOINT}/${id}`);
}

export function getConsignSupplierList(params?: SearchModel) {
  return axios.get<PaginateModel<ConsignSupplierModel>>(ADMIN_CONSIGNMENT_SUPPLIER_ENDPOINT, {params});
}

export function connectConsignSupplier(id: number, selectedIds: number[]) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/connect-consigment-supplier/${id}`, {supplier_ids: selectedIds});
}

export function updateOpeningConfig(params: object) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/update-opening`, params);
}

export function updateBank(params: object) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/update-bank`, params);
}

export function addBank(params: object) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/add-bank`, params);
}

export function removeBank(id: number) {
  return axios.delete<ResponseModel>(`${ADMIN_STORES_ENDPOINT}/remove-bank/${id}`);
}

export function updateAddress(params: object) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/update-address`, params);
}

export function addAddress(params: object) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/add-address`, params);
}

export function removeAddress(id: number) {
  return axios.delete<ResponseModel>(`${ADMIN_STORES_ENDPOINT}/remove-address/${id}`);
}

export function allowShareProducts(params: object) {
  return axios.post(`${ADMIN_STORES_ENDPOINT}/allow_share_products`, params);
}
